import styled from "styled-components";

export const TagsGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    max-height: 44px;
    overflow: hidden;
    padding-right: 40px;
    position: relative;
`;

export const TagsOverflow = styled.div`
    position: absolute;
    right: 0;
    bottom: 0;
`;